import { MARKED_CET1_DEFINITION } from "@gxs/metric-defs";
/** The fact sheet is a clause list ("total assets $12.0B; loans $8.4B; …"): each clause splits at its first figure into a label and a value. */
export interface FactRow { readonly label: string; readonly value: string }

const sentenceCase = (text: string): string => text.charAt(0).toUpperCase() + text.slice(1);

export function factRows(text: string): readonly FactRow[] {
  return text.replace(/\.$/, "").split(/;\s*/).filter((c) => c.trim() !== "").map((clause) => {
    const m = /^(.*?)\s+(\$?\d.*)$/.exec(clause);
    const label = (m?.[1] ?? clause).replace(/\s+(?:is|are)$/, "");
    return { label: sentenceCase(label), value: m?.[2] ?? "" };
  });
}

/** One clause for each term a reader may not know, said only when the fact sheet uses it. */
const TERM_NOTES: readonly (readonly [RegExp, string])[] = [
  [/\bFHLB\b/, "FHLB: the Federal Home Loan Bank, which lends to banks against pledged collateral"],
  [/\bduration\b/i, "Average duration: how many years of rate sensitivity the bonds carry; higher means bigger price swings"],
  [/\bmarked CET1\b/i, `Marked CET1: ${MARKED_CET1_DEFINITION}`],
];
export const termNotes = (text: string): readonly string[] => TERM_NOTES.filter(([re]) => re.test(text)).map(([, note]) => note);
